import React from "react";

export default function PlatformNewsArticleHeader({
                                                      newsItem,
                                                      subtitle,
                                                  }) {
    return (
        <header className="platform-news-article__header">
            <div className="platform-news-article__header-content">
                <span className="platform-news-article__category">
                    {newsItem.category}
                </span>

                <h1 className="platform-news-article__title">
                    {newsItem.title}
                </h1>

                {subtitle && (
                    <p className="platform-news-article__subtitle">
                        {subtitle}
                    </p>
                )}

                <div className="platform-news-article__meta">
                    <time dateTime={newsItem.dateTime}>
                        {newsItem.date}
                    </time>

                    <span>{newsItem.author}</span>
                </div>
            </div>

            <img
                className="platform-news-article__cover"
                src={newsItem.image}
                alt={newsItem.imageAlt}
                width="1200"
                height="630"
                loading="eager"
            />
        </header>
    );
}